import { AppState } from 'services/types';
import { WorksheetState } from './types';

const selectWorksheet = (state: AppState): WorksheetState => state.worksheet;

export { selectWorksheet };
